// FilterList
import React from 'react';
import PropTypes from 'prop-types';

const FilterSelectionListItem = ({ filterClick, option }) => {
  const id = option.name.toLowerCase().replace(/[\s]+/g, '-').replace(/-&/g, '');
  const isColorOption = option.inputName.indexOf('color-option') !== -1;
  return (
    <li key={id} role="menuitem" className={`filter-option ${(option.isHidden) ? 'hidden' : ''}`}>
      <input id={id} name={option.inputName} type={option.type} value={option.value} onChange={() => filterClick(option)} checked={(option.isChecked === true ? 'checked' : '')} />
      <label className="checkbox-label" htmlFor={id}>
        {isColorOption
          && (
            <div className={`filter-color-option ${option.name.toLowerCase().replace(/[\s]+/g, '-').replace(/-&/g, '')}`} />
          )
        }
        {option.name}
      </label>
    </li>
  );
};

FilterSelectionListItem.propTypes = {
  filterClick: PropTypes.func.isRequired,
  option: PropTypes.shape({
    id: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    inputName: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    image: PropTypes.string.isRequired,
    isHidden: PropTypes.bool.isRequired,
    isChecked: PropTypes.bool.isRequired,
  }),
};

const FilterSelectionList = props => (
  <ul role="menu" className={`${props.filter.name.toLowerCase().replace(/[\s]+/g, '-')}-selection-list`} id={`${props.filter.name.toLowerCase().replace(/[\s]+/g, '-')}-selection-list`} aria-labelledby={`${props.filter.name.toLowerCase().replace(/[\s]+/g, '-')}-filter-heading`}>
    {props.filter.options.map(option => (
      <FilterSelectionListItem key={option.name.toLowerCase().replace(/[\s]+/g, '-')} {...Object.assign({}, props, { option })} />
    ))}
    {props.filter.showMore
      && (
        <li role="menuitem"><button className="show-more-btn" type="button" onClick={event => props.showAllFilterItems(event, props.filter.name)}>Show more {props.filter.name}s ({props.filter.options.length})</button></li>
      )
    }
  </ul>
);

FilterSelectionList.propTypes = {
  showAllFilterItems: PropTypes.func.isRequired,
  filter: PropTypes.shape({
    name: PropTypes.string.isRequired,
    active: PropTypes.bool.isRequired,
    showMore: PropTypes.bool.isRequired,
    options: PropTypes.arrayOf(PropTypes.object),
  }),
  option: PropTypes.shape({
    name: PropTypes.string.isRequired,
  }),
};

const FilterSetListItem = props => (
  <div className={`filter filter-set ${(props.filter.active === true ? 'is-active' : '')}`}>
    <button
      type="button"
      id={`${props.filter.name.toLowerCase().replace(/[\s]+/g, '-')}-filter-heading`}
      className="filter-heading"
      aria-expanded={props.filter.active}
      aria-controls={`${props.filter.name.toLowerCase().replace(/[\s]+/g, '-')}-selection-list`}
      onClick={event => props.buttonClick(event, props.filter.name)}
    >
      {props.filter.name}
      <span className="icon" />
    </button>
    <FilterSelectionList {...props} />
  </div>
);

FilterSetListItem.propTypes = {
  buttonClick: PropTypes.func.isRequired,
  filter: PropTypes.shape({
    name: PropTypes.string.isRequired,
    active: PropTypes.bool.isRequired,
  }),
};

const FilterSetList = props => (
  <div>
    {Object.keys(props.filters).filter(key => typeof props.filters[key] !== 'string').sort((keyA, keyB) => props.filters[keyA].order - props.filters[keyB].order).map(key => (
      <FilterSetListItem key={key} order={props.filters[key].order} {...props} filter={props.filters[key]} />
    ))}
  </div>
);

FilterSetList.propTypes = {
  filters: PropTypes.shape(PropTypes.object),
  filter: PropTypes.shape({
    order: PropTypes.number.isRequired,
  }),
};

export {
  FilterSetList,
  FilterSetListItem,
  FilterSelectionList,
  FilterSelectionListItem,
};
